import { FspCalculateMethodPolicy } from "constants/common/FspCalculateMethodPolicy";
import _ from "lodash";

export const FspCalculateMethodDroOpts = () => {

    const getDroOptsModel = (chargeType: string, subChargeType: string) => {
        let ret: string[] = [];
        if (chargeType === "RFH" && subChargeType === "T1") {
            ret = [FspCalculateMethodPolicy.ITEM_SPLITTING];
        } else {
            ret = [FspCalculateMethodPolicy.ITEM_CALENDAR, FspCalculateMethodPolicy.ITEM_EXACT];
        }
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    return {
        getDroOptsModel
    }
}